import { ReactElement } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Icon,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { IoInformationCircleOutline } from "react-icons/io5";
import { useModifiedTranslation } from "../../../hooks/useModifiedTranslation";

/*
 * 通知の受信設定の「i」。押すと、title を見出しに、description を本文にしたシートを下から出す。
 * アプリ全体の文字は太字なので、本文は通常の太さに戻す
 */
export function NotificationSettingInfo(
  props: Readonly<{ title: string; description: string; testId?: string }>,
): ReactElement {
  const { title, description, testId } = props;
  const t = useModifiedTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <IconButton
        aria-label={t("NotificationSetting.infoLabel", { title })}
        icon={<Icon as={IoInformationCircleOutline} boxSize={5} />}
        variant="ghost"
        size="sm"
        onClick={onOpen}
        data-testid={testId && `${testId}-info`}
      />
      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent
          pb={5}
          backgroundColor="primary.bg_lv1"
          data-testid={testId && `${testId}-info-sheet`}
        >
          <DrawerCloseButton />
          <DrawerHeader>{title}</DrawerHeader>
          <DrawerBody fontWeight="normal" whiteSpace="pre-line">
            {description}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
